
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useDisciplineAnalytics = (timeRange: number = 30) => {
  return useQuery({
    queryKey: ['discipline-analytics', timeRange],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_discipline_analytics', {
        days_back: timeRange
      });
      if (error) throw error;
      return data || [];
    },
  });
};

export const usePillarAnalytics = (timeRange: number = 30) => {
  return useQuery({
    queryKey: ['pillar-analytics', timeRange],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_pillar_analytics', {
        days_back: timeRange
      });
      if (error) throw error;
      return data || [];
    },
  });
};

export const useThematicTrailAnalytics = () => {
  return useQuery({
    queryKey: ['thematic-trail-analytics'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_thematic_trail_analytics');
      if (error) throw error;
      return data || [];
    },
  });
};

export const useCrossDisciplinaryMetrics = () => {
  return useQuery({
    queryKey: ['cross-disciplinary-metrics'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_cross_disciplinary_metrics');
      if (error) throw error;
      return data?.[0] || {
        total_connections: 0,
        connection_strength: 0,
        discipline_pairs: {}
      };
    },
  });
};

export const useEngagementHeatmap = () => {
  return useQuery({
    queryKey: ['engagement-heatmap'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_engagement_heatmap');
      if (error) throw error;
      return data || [];
    },
  });
};

export const useLearningPathAnalytics = () => {
  return useQuery({
    queryKey: ['learning-path-analytics'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_learning_path_analytics');
      if (error) throw error;
      return data?.[0] || {
        total_paths: 0,
        completed_paths: 0,
        average_completion_time: 0,
        most_popular_starting_points: [],
        dropout_points: []
      };
    },
  });
};
